import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { MarketDataDetailsService } from '@app/feature/main/roles-shared/services/market-data-details.service';
import { ModalServiceService } from '@app/feature/main/roles-shared/services/modal-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { MarketDataChartGeneratorService } from '@app/feature/main/roles-shared/services/market-data-chart-generator.service';
import { MarketData, AdminFilteredData, MarketDataChartJSON } from '@app/feature/main/roles-shared/models/marketDataModel';
import swal from 'sweetalert2';
import { AuthenticationService } from '@app/shared/services/authentication.service';
declare var $: any

@Component({
  selector: 'app-market-data-details',
  templateUrl: './market-data-details.component.html',
  styleUrls: ['./market-data-details.component.css']
})
export class MarketDataDetailsComponent implements OnInit, OnDestroy {

  dataSubscriptionService = new Subscription();
  bookmarkedMarketData: any;
  marketDataContent: any = new MarketData();
  highChartSubscrition: any;
  marketDat: any = {
    ChartJSON: {
    }
  };
  filterModalStatus: boolean = false;
  noFiltersApplied: boolean;

  benchMarkModalStatus: boolean = false;
  benchMarkFilter: any = {
    againstAll: false,
    againstMyDomain: false
  }

  timeLineAnalysisModalStatus: boolean = false;
  timeLineAnalysisFilter: any = {

  }
  timeAnalysisStartDate: Date;
  timeAnalysisEndDate: Date;
  researchDocumentId: string;
  marketDataId: string;
  userRole: any;
  isShowArrow:boolean=false;
  userFilterList: any;


  constructor(
    private marketDataDetailsService: MarketDataDetailsService,
    private modalServiceService: ModalServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private rolesSharedService: RolesSharedService,
    private marketDataChartGeneratorService: MarketDataChartGeneratorService,
    private cd: ChangeDetectorRef,
    private location: Location,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.researchDocumentId = this.route.snapshot.paramMap.get("researchId");
    this.marketDataId = this.route.snapshot.paramMap.get("marketDataId");
    this.marketDat = this.route.snapshot.data.marketData;
    this.marketDat.numberOfResponse = null;
    // filter disabled for bubble chart
    if (this.marketDat.graphType.graphType == "bubble_chart") {
     this.chartFilterApplied(this.marketDat);
    } else {
      this.refreshMarketData();
    }
    this.getRole();
  }

  ngOnDestroy() {
    this.modalServiceService.close();
    this.dataSubscriptionService.unsubscribe();
    sessionStorage.removeItem("fromReports");
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  marketDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        "subCategory",
        "graphType",
        {
          likes: "user"
        },
        {
          comments: "user"
        },
        {
          bookmark: "user"
        },
        {
          ratings: "user"
        }
      ]

    });

    return filter;
  }

  getMarketData() {
    if (this.researchDocumentId && this.marketDataId) {
      this.rolesSharedService.getMarketData(
        this.marketDataId, this.marketDataFilter(), this.researchDocumentId
        ).subscribe((marketDat: any) => {
        this.marketDat = marketDat;
        this.refreshMarketData();
      });
    } else {
      this.noDataRoute();
    }
  }

  refreshMarketData() {
    // Fetch Bookmarked data with applied filters from market-data-details service
    this.marketDat.userFilteredData = this.marketDataDetailsService.getUserFilteredData();
    if (this.marketDat.userFilteredData === undefined && !sessionStorage.getItem("fromReports")) {
      this.goBack();
    } else if (this.marketDat.userFilteredData === undefined && sessionStorage.getItem("fromReports") === "true") {
      this.marketDat.userFilteredData = {
        countryId: [],
        employeeSizeId: [],
        geographyId: [],
        industryId: [],
        itBudgetId: [],
        jobTitleId: [],
        lineOfBusinessId: [],
        globalRevenueId: []
      };
    }
    this.marketDat.userFilters.solution = JSON.parse(sessionStorage.getItem('bookmarkedSolution'));
    this.dataSubscriptionService = this.marketDataDetailsService.dataSource.subscribe(
        (savedMarketData: any) => {
          // This will be called whenever datasource(`this.marketDat` here) is updated
          this.loadAppliedFilters();
        }
      );

  }

  loadAppliedFilters() {
    this.userFilterList = this.marketDataDetailsService.populateMarketDataFilterSelection(
      this.marketDat.userFilters, this.marketDat.userFilteredData
    );
    // Show applied Filters in UI
    this.getAppliedFilters();
    // Apply Filters to marketData
    this.filterApply();
  }

  // Fetch filters with applied filters marked - status: true
  getAppliedFilters() {
    this.marketDat.userAppliedFilterList = this.marketDataDetailsService
    .getAppliedFilters(this.userFilterList);
    this.checkFiltersApplied();
  }

  filterApply() {
    this.marketDat.apply = true;
    // Copy marketData - content object to API payload
    this.marketDataContent = this.marketDat.content;
    // Copy applied filters to API payload
    for (let key in this.marketDat.userFilteredData) {
      this.marketDataContent[key] = this.marketDat.userFilteredData[key];
    }
    this.marketDataContent[`marketDataId`] = this.marketDat.id;
    this.marketDataContent[`isClustered`] = this.marketDat.isClustered || false;
    this.rolesSharedService.filterMarketData(this.marketDataContent, this.researchDocumentId)
    .subscribe((filteredData: any) => {
      this.marketDat.marketData = filteredData.data;
      this.marketDat.numberOfResponse = filteredData.numberOfResponse;
      this.chartFilterApplied(this.marketDat);
    });
  }

  chartFilterApplied(filterdData?: any) {
    this.marketDat.ChartJSON = [];
    this.marketDataChartGeneratorService.generateChartJSON(filterdData).subscribe((chartJSON: any) => {
      this.marketDat.ChartJSON = chartJSON;
      this.marketDataDetailsService.setMarketData(this.marketDat);
      this.marketDataDetailsService.setMarketDataFilter(this.marketDat.userFilters);
      this.cd.detectChanges();
    });
  }

  openFilterModal() {
    this.modalServiceService.open();
  }

  setStatusBenchmarkModal(status: boolean, subscription?: any) {
    if (status == true) {
      $('#benchMarkModal').modal('show');
      this.benchMarkModalStatus = true;
    } else if (status == false) {
      $('#benchMarkModal').modal('hide');
      this.benchMarkModalStatus = false;
    }
  }

  noDataRoute() {
    this.router.navigate([``]);
  }

  becnchMarkChanges(benchMarkClick: any) {
    if (benchMarkClick == 'allDomain') {
      this.benchMarkFilter.againstAll = true;
      this.benchMarkFilter.againstMyDomain = false;
      this.benchMarkFilter.myDomainVsAllDomain = false;
    } else if (benchMarkClick == 'myDomain') {
      this.benchMarkFilter.againstAll = false;
      this.benchMarkFilter.againstMyDomain = true;
      this.benchMarkFilter.myDomainVsAllDomain = false;
    } else if (benchMarkClick == 'myDomainVsAllDomain') {
      this.benchMarkFilter.againstAll = false;
      this.benchMarkFilter.againstMyDomain = false;
      this.benchMarkFilter.myDomainVsAllDomain = true;
    } else if (!benchMarkClick) {
      this.benchMarkFilter.againstAll = false;
      this.benchMarkFilter.againstMyDomain = false;
    }
  }

  saveBenchMarkFilter() {
    let filter: any = {};
    filter = this.marketDat.content;
    this.marketDat.content[`marketDataId`] = this.marketDat.id;
    this.marketDat.content[`isClustered`] = this.marketDat.isClustered || false;
    filter.userBenchmark = this.benchMarkFilter;
    this.rolesSharedService.filterMarketData(filter, this.researchDocumentId).subscribe((filteredData: any) => {
      this.rolesSharedService.getMarketData(this.marketDat.id, this.marketDataFilter()).subscribe((marketDat: any) => {
        this.marketDat = marketDat;
        if (filteredData.data && filteredData.data.length > 0) {
          this.marketDat.marketData.forEach((marketData: any) => {
            if (marketData.doc_count) {
              marketData.doc_count = 0;
            }
            if (marketData.doc_percentage) {
              marketData.doc_percentage = 0;
            }
            marketData.benchmarkFilterAdded = true;
          });
          filteredData.data.forEach((data: any) => {
            this.marketDat.marketData.push(data);
          });
        }
        this.marketDataChartGeneratorService.generateChartJSON(this.marketDat).subscribe((chartJSON: any) => {
          $("#benchMarkModal").modal('hide');
          this.marketDat.ChartJSON = chartJSON;
          // this.marketDataDetailsService.marketData(this.marketDat);
          // this.marketDataDetailsService.marketDataFilter(this.userFiltersAdded);
          // this.userFilterListClone = _.cloneDeep(this.userFiltersAdded)
          // this.close();
        })
      });
    })
  }

  setStatusTimeLineAnalysisModal(status: boolean, subscription?: any) {
    if (status == true) {
      $('#timeLineAnalysisModal').modal('show');
      this.timeLineAnalysisModalStatus = true;
    } else if (status == false) {
      $('#timeLineAnalysisModal').modal('hide');
      this.timeLineAnalysisModalStatus = false;
    }
  }

  timeLineAnalysisChanges() {
    this.timeLineAnalysisFilter.startDate = this.timeAnalysisStartDate;
    this.timeLineAnalysisFilter.endDate = this.timeAnalysisEndDate;
  }

  saveTimeLineAnalysisFilter() {
    if (this.timeAnalysisStartDate < this.timeAnalysisEndDate) {
      this.timeLineAnalysisChanges();
      let filter: any = {}
      filter = this.marketDat.content;
      filter[`marketDataId`] = this.marketDat.id;
      filter[`isClustered`] = this.marketDat.isClustered || false;
      filter.timeline = this.timeLineAnalysisFilter;
      this.rolesSharedService.filterMarketData(filter, this.researchDocumentId).subscribe((filteredData: any) => {
        this.rolesSharedService.getMarketData(this.marketDat.id, this.marketDataFilter()).subscribe((marketDat: any) => {
          this.marketDat = marketDat;
          if (filteredData.data && filteredData.data.length > 0) {
            this.marketDat.marketData.forEach((marketData: any) => {
              marketData.doc_count = 0;
            });
            filteredData.data.forEach((data: any) => {
              this.marketDat.marketData.push(data);
            });
          } else {
            this.marketDat.marketData.forEach((marketData: any) => {
              marketData.doc_count = 0;
            });
          }
          this.marketDataChartGeneratorService.generateChartJSON(this.marketDat).subscribe((chartJSON: any) => {
            $("#timeLineAnalysisModal").modal('hide');
            this.marketDat.ChartJSON = chartJSON;
          })
        });
      })
    } else {
      swal({
        position: "center",
        type: "info",
        title: "Please choose a valid date range",
        showConfirmButton: false,
        timer: 2000
      });
    }
  }

  setFilterModal(status: boolean, subscription?: any) {
    if (status == true) {
      $('#marketDataFilterModal').modal('show');
      this.filterModalStatus = true;
    } else if (status == false) {
      $('#marketDataFilterModal').modal('hide');
      this.filterModalStatus = false;
    }
  }

  goBack(){
    this.location.back();
  }

  // Check if any filters applied or not
  checkFiltersApplied() {
    this.noFiltersApplied = this.marketDataDetailsService.checkFiltersApplied(
    this.marketDat.userAppliedFilterList);
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/market-data-details/market-data-details.component.ts